export const MY_ISSUANCE_API_PATH = {
  GET_ISSUANCE_LIST: "v1/flights/issuances/",
  GET_ISSUANCE_DETAILS: "v1/flights/issuance-detail/",
};
